import script from "./SupplierPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierPage.vue?vue&type=script&setup=true&lang=js"

import "./SupplierPage.vue?vue&type=style&index=0&id=7ca33c00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca33c00"]])

export default __exports__